import {CgArrowsExchangeV} from 'react-icons/cg'
import {FaJava, FaReact} from 'react-icons/fa'
import {GrTest} from 'react-icons/gr'
import {
    SiJavascript,
    SiJest,
    SiMui,
    SiRedux,
    SiSass,
    SiStorybook,
    SiTypescript,
    SiNextdotjs
} from 'react-icons/si'
import {TbApi} from 'react-icons/tb'


export const skills = [
    {
        skillID: 1,
        title: 'React',
        Icons: FaReact,
        fill: '#61DAFB'
    },
    {
        skillID: 2,
        title: 'Next.js',
        Icons: SiNextdotjs,
        fill: '#ffffff'
    },
    {
        skillID: 3,
        title: 'Redux',
        Icons: SiRedux,
        fill: '#764abc',
    },
    {
        skillID: 4,
        title: 'JavaScript',
        Icons: SiJavascript,
        fill: '#f5de19',
    },
    {
        skillID: 5,
        title: 'TypeScript',
        Icons: SiTypescript,
        fill: '#0a12a6',
    },
    {
        skillID: 6,
        title: 'Java',
        Icons: FaJava,
        fill: '#007acc',
    },
    {
        skillID: 7,
        title: 'Axios',
        Icons: CgArrowsExchangeV,
        fill: '#671ddf',
    },
    {
        skillID: 8,
        title: 'Jest',
        Icons: SiJest,
        fill: '#c63d14',
    },
    {
        skillID: 9,
        title: 'SASS-SCSS',
        Icons: SiSass,
        fill: '#bf4080',
    },
    {
        skillID: 10,
        title: 'Rest-API',
        Icons: TbApi,
        fill: '#f9004d',
    },
    {
        skillID: 11,
        title: 'StoryBook',
        Icons: SiStorybook,
        fill: '#FF4785',
    },
    {
        skillID: 12,
        title: 'MUI',
        Icons: SiMui,
        fill: '#007FFF',
    },
    {
        skillID: 13,
        title: 'Unit-tests',
        Icons: GrTest,
        fill: '#66bb6a',
    },
]